/**
 * This file was auto-generated by Fern from our API Definition.
 */
import * as core from "../../../../core";
import { SpaceId } from "../../commons/types/SpaceId";
import { EnvironmentId } from "../../commons/types/EnvironmentId";
import { SheetConfig } from "../../sheets/types/SheetConfig";
import { Action } from "../../commons/types/Action";
import { WorkbookConfigSettings } from "./WorkbookConfigSettings";
import { WorkbookTreatments } from "./WorkbookTreatments";
import { StorageStrategy } from "./StorageStrategy";
export const CreateWorkbookConfig = core.serialization.object({
    name: core.serialization.string(),
    labels: core.serialization.list(core.serialization.string()).optional(),
    spaceId: SpaceId.optional(),
    environmentId: EnvironmentId.optional(),
    namespace: core.serialization.string().optional(),
    sheets: core.serialization.list(SheetConfig).optional(),
    actions: core.serialization.list(Action).optional(),
    settings: WorkbookConfigSettings.optional(),
    metadata: core.serialization.any().optional(),
    treatments: core.serialization.list(WorkbookTreatments).optional(),
    storageStrategy: StorageStrategy.optional(),
    folder: core.serialization.string().optional(),
});
